/** @file foldYawFlip: folds a pitch beyond +-90 degrees back into range and turns the yaw by 180 (18.4). */
import { wrapDegrees } from '@zilo/pose3d-std/math/wrapDegrees';

/**
 * `|pitchDeg| > 90` -> pitch `sign * 180 - pitch`, yaw + 180 (wrapped to [0, 360)), `flipped`; otherwise the angles
 * as given (yaw wrapped). `pitchDeg` is the full-circle read-back made relative (21.1: never pre-folded by pose); only
 * entries with `yawFlip` use the folded yaw, and the band stays the unfolded pitch's (decision 12, 18.4).
 */
export function foldYawFlip(
  yawDeg: number, pitchDeg: number, out: { yawDeg: number; pitchDeg: number; flipped: boolean },
): typeof out {
  const flipped = Math.abs(pitchDeg) > 90;
  out.flipped = flipped;
  out.pitchDeg = flipped ? Math.sign(pitchDeg) * 180 - pitchDeg : pitchDeg;
  out.yawDeg = wrapDegrees(flipped ? yawDeg + 180 : yawDeg);
  return out;
}
